import { useState } from 'react'
import { useAccountSummary, useCreditAccounts } from 'const/syfApiQueries'
import setCookiesForMarketPlaceRedirect from 'helpers/setCookiesForMarketPlaceRedirect'
import hasPCSSAccounts from '../helpers/hasPCSSAccounts'
import handleLogout from '../helpers/handleLogout'
import config from '../const/config'

const useLogoutRedirect = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(true)
  const { data: { accounts = [] } = {}, isError: isCreditAccountsAPIError } =
    useCreditAccounts()
  const accountId = accounts[0]?.info['cipher.accountId']

  const { data: accountSummary, isError: isAccountSummaryError } =
    useAccountSummary(accountId)

  if (
    accounts.length === 0 ||
    isCreditAccountsAPIError ||
    isAccountSummaryError
  ) {
    return {
      isLoggedIn,
      isLogoutDisabled: !isLoggedIn,
      handleLogoutAndRedirect: () => {
        setIsLoggedIn(false)
        handleLogout()
      }
    }
  }

  return {
    isLoggedIn,
    isLogoutDisabled: !isLoggedIn,
    handleLogoutAndRedirect: (
      pageFunction: string = '',
      dataType: string = ''
    ) => {
      let logOffUrl
      let intcmpValue = ''
      setIsLoggedIn(false)
      if (hasPCSSAccounts(accounts)) {
        const pageFnc = pageFunction?.split(' ').join('')
        const clientName = accountSummary.product.clientId
        /**
         * intcmp value should look like SiteIdentifier_ClientName_pgfunc_data-type_internaldomain_int
         */
        const intcmpIndividualAttributes = [
          'vista',
          clientName,
          pageFnc,
          dataType,
          'synchrony',
          'int'
        ]
        setCookiesForMarketPlaceRedirect(clientName)
        logOffUrl = config.MARKETPLACE_URL

        // Get the filter list, where the attributes are not empty
        const filteredIntcmpIndividualAttributes =
          intcmpIndividualAttributes.filter(
            (intcmpAttribute) =>
              intcmpAttribute && intcmpAttribute.trim().length > 0
          )
        intcmpValue = filteredIntcmpIndividualAttributes.join('_')
      }
      handleLogout(logOffUrl, intcmpValue)
    }
  }
}

export default useLogoutRedirect
